export const translations = {
  FORM_NAMESPACE: 'ariaLabels',
  HONEYPOT_LABEL_KEY: 'forms_ariaLabel_hiddenInput',
  HONEYPOT_LABEL_DEFAULT: 'Please leave this field empty.',
};
